export const getDateWithOffset = (date: string) => {
  if (parseDate(date)) {
      var dateWithTimezone = new Date(date);
      var utcOffset = dateWithTimezone.toISOString();
      
      return new Date(utcOffset);
    }
    return null;
  };

  function parseDate(date: string) {
    const parsed = Date.parse(date);
    if (!isNaN(parsed)) {
      return parsed;
    }
    else if(date != null)
      return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
    else
      return null;
  }